export default Object.freeze({
  SendMessage: 'send-message',
});
